import FAQ from 'components/faqs/SingleCol.js';
import Features from 'components/features/ThreeColWithSideImage.js';
import MainFeature2 from 'components/features/TwoColWithTwoFeaturesAndButtons';
import Footer from 'components/footers/MiniCenteredFooter';
import TwoColContactUsWithIllustrationFullForm from 'components/forms/TwoColContactUsWithIllustrationFullForm';
import Hero from 'components/hero/JovanHero';
import SEO from 'components/SEO';
import { ReactComponent as ArrowRightIcon } from 'feather-icons/dist/icons/arrow-right.svg';
import { ReactComponent as CheckIcon } from 'feather-icons/dist/icons/check.svg';
import { ReactComponent as DatabaseIcon } from 'feather-icons/dist/icons/database.svg';
import { ReactComponent as ViewIcon } from 'feather-icons/dist/icons/eye.svg';
import { ReactComponent as FileTextIcon } from 'feather-icons/dist/icons/file-text.svg';
import { ReactComponent as LinkIcon } from 'feather-icons/dist/icons/link.svg';
import { ReactComponent as MailIcon } from 'feather-icons/dist/icons/mail.svg';
import { ReactComponent as PlayIcon } from 'feather-icons/dist/icons/play.svg';
import { ReactComponent as SearchIcon } from 'feather-icons/dist/icons/search.svg';
import { ReactComponent as SlidersIcon } from 'feather-icons/dist/icons/sliders.svg';
import { ReactComponent as TrendingUpIcon } from 'feather-icons/dist/icons/trending-up.svg';
import { ReactComponent as UsersIcon } from 'feather-icons/dist/icons/users.svg';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import CustomizeIconImage from 'images/customize-icon.svg';
import FastIconImage from 'images/fast-icon.svg';
import Image2Src from 'images/landing/2.png';
import Image3Src from 'images/landing/3.png';
import Image5Src from 'images/landing/5.png';
import Image6Src from 'images/landing/6.png';
import ReliableIconImage from 'images/reliable-icon.svg';
import ShieldIconImage from 'images/shield-icon.svg';
import SimpleIconImage from 'images/simple-icon.svg';
import SupportIconImage from 'images/support-icon.svg';
import tw from 'twin.macro';

export default () => {
    const Bold = tw.span`font-bold`;
    const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
    const HighlightedText = tw.span`text-primary-500`;

    return (
        <AnimationRevealPage disabled>
            <SEO
                title="Poslovna analitika | Prodajna analitika i BI reporting"
                description="Prodajna analiza i automatizacija izveštavanja koja donosi rezultate. Povećajte prihod, prepoznajte ključne prilike i preduhitrite pad prodaje."
                image="https://poslovna-analitika.rs/stats-illustration.png"
            />
            <Hero roundedHeaderButton={true} />
            <MainFeature2
                subheading=""
                heading={<>Prodajna analitika</>}
                imageSrc={Image3Src}
                image2Src={Image5Src}
                description={
                    <>
                        Upravljajte prodajnim podacima uz naprednu automatizaciju i BI reporting.{' '}
                        <Bold>Povećajte prihod, prepoznajte ključne prilike i preduhitrite pad prodaje.</Bold>
                    </>
                }
                features={[
                    {
                        Icon: SlidersIcon,
                        title: 'Kontrola',
                        description: 'Ne moraš čekati kraj meseca da bi znao šta se najviše prodaje.',
                    },
                    {
                        Icon: ViewIcon,
                        title: 'Pregled',
                        description: (
                            <>
                                Mini analiza ti daje ono što dosad nisi imao:{' '}
                                <Bold>brz i jasan pregled prodajnih performansi, kao i ostalih delova poslovanja.</Bold>
                            </>
                        ),
                    },
                    {
                        Icon: CheckIcon,
                        title: 'Jednostavnost',
                        description: 'Bez dodatnog zapošljavanja i bez kompleksnih alata.',
                    },
                    {
                        Icon: ArrowRightIcon,
                        title: 'Prodaja',
                        description: (
                            <>
                                Ti prodaješ – mi ti dajemo <Bold>podatke koji ti pomažu da prodaješ pametnije</Bold>.
                            </>
                        ),
                    },
                ]}
                textOnLeft={false}
            />
            <Features
                subheading=""
                heading={
                    <>
                        Glavni izazovi koje <HighlightedText>rešavamo</HighlightedText>
                    </>
                }
                description=""
                cards={[
                    {
                        imageSrc: ShieldIconImage,
                        title: 'Slabi prodajni rezultati ',
                        description: 'Vidi koji proizvodi ili prodajna mesta stvarno zarađuju.',
                    },
                    {
                        imageSrc: SupportIconImage,
                        title: 'Nepregledni podaci o kupcima ',
                        description: 'Segmentiranja po vrednosti, ponašanju i navikama.',
                    },
                    {
                        imageSrc: CustomizeIconImage,
                        title: 'Nedostatak uvida u trendove ',
                        description: 'Identifikuj sezonalnost, padove i šanse za upsell, crossell itd.',
                    },
                    {
                        imageSrc: ReliableIconImage,
                        title: 'Ručno izveštavanje ',
                        description: 'Sve ključne analize automatizovane, bez trošenja sati na Excel.',
                    },
                    {
                        imageSrc: FastIconImage,
                        title: 'Teško donošenje prodajnih odluka',
                        description: 'Imaj jasne podatke kad odlučuješ o zalihama, akcijama ili planovima.',
                    },
                    {
                        imageSrc: SimpleIconImage,
                        title: 'Jednostavno do rezultata',
                        description: 'Uštedite vreme koristeći jedan alat za sve što vam je potrebno.',
                    },
                ]}
            />
            <MainFeature2
                subheading={<Subheading id="o-nama">O nama</Subheading>}
                hideTitle={true}
                heading={<>Poslovna analitika</>}
                imageSrc={Image6Src}
                image2Src={Image2Src}
                showDecoratorBlob={false}
                description={
                    <>
                        Mi smo <Bold>Poslovna analitika</Bold>, firma specijalizovana za{' '}
                        <Bold>naprednu prodajnu i poslovnu analitiku</Bold>. Razvijamo moderna BI rešenja koja pomažu
                        malim i srednjim firmama da:
                    </>
                }
                features={[
                    {
                        Icon: TrendingUpIcon,
                        description: 'Rastu brže i pametnije',
                    },
                    {
                        Icon: UsersIcon,
                        description: 'Razumeju svoje kupce i proizvode',
                    },
                    {
                        Icon: DatabaseIcon,
                        description: (
                            <>
                                Povećaju prihode kroz podatke – <Bold>bez dodatne papirologije ili ručnih analiza</Bold>
                            </>
                        ),
                    },
                ]}
                description2={
                    <>
                        <Bold>Šta radimo?</Bold>
                    </>
                }
                features2={[
                    {
                        Icon: LinkIcon,
                        description: 'Povezujemo podatke iz vaših baza podataka.',
                    },
                    {
                        Icon: PlayIcon,
                        description: (
                            <>
                                Automatizujemo <Bold>prodajne analize i ključne KPI izveštaje</Bold>.
                            </>
                        ),
                    },
                    {
                        Icon: FileTextIcon,
                        description: 'Kreiramo BI izveštaje.',
                    },
                    {
                        Icon: SearchIcon,
                        description: (
                            <>
                                Omogućujemo <Bold>brze preglede</Bold> za bolju prodajnu strategiju.
                            </>
                        ),
                    },
                ]}
                description3={
                    <>
                        Bez obzira jeste li vlasnik, direktor prodaje ili prodajni konsultat – dobićete alat koji{' '}
                        <Bold>prati šta se prodaje i gde ima prostora za rast</Bold>.
                    </>
                }
            />
            {/* <ThreeColCenteredStatsPrimaryBackground
                heading="Preko 100 zadovoljnih klijenata"
                description="Naš BI alat je pomogao mnogim firmama da unaprede svoje poslovanje i ostvare značajne rezultate."
                stats={[
                    {
                        key: 'Povećanje prihoda',
                        value: '32%',
                    },
                    {
                        key: 'Brže donošenje odluka',
                        value: '5x',
                    },
                    {
                        key: 'Godine iskustva',
                        value: '10+',
                    },
                ]}
            /> */}
            {/* <Pricing
                subheading={<Subheading>Pricing</Subheading>}
                heading={
                    <>
                        Reasonable & Flexible <HighlightedText>Plans.</HighlightedText>
                    </>
                }
                plans={[
                    {
                        name: "Personal",
                        price: "$17.99",
                        duration: "Monthly",
                        mainFeature: "For Individuals",
                        features: ["30 Templates", "7 Landing Pages", "12 Internal Pages", "Basic Assistance"],
                    },
                    {
                        name: "Business",
                        price: "$37.99",
                        duration: "Monthly",
                        mainFeature: "For Small Businesses",
                        features: ["60 Templates", "15 Landing Pages", "22 Internal Pages", "Priority Assistance"],
                        featured: true,
                    },
                    {
                        name: "Enterprise",
                        price: "$57.99",
                        duration: "Monthly",
                        mainFeature: "For Large Companies",
                        features: ["90 Templates", "27 Landing Pages", "37 Internal Pages", "Personal Assistance"],
                    },
                ]}
            /> */}
            {/* <Testimonial
                subheading={<Subheading id="utisci">Drugi o nama</Subheading>}
                heading={
                    <>
                        Uspešne <HighlightedText>priče</HighlightedText> i <HighlightedText>rezultati</HighlightedText>.
                    </>
                }
                description=""
                testimonials={[
                    {
                        stars: 5,
                        profileImageSrc:
                            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80',
                        heading: 'Amazing User Experience',
                        quote: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
                        customerName: 'Charlotte Hale',
                        customerTitle: 'Director, Delos Inc.',
                    },
                    {
                        stars: 5,
                        profileImageSrc:
                            'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80',
                        heading: 'Love the Developer Experience and Design Principles !',
                        quote: 'Sinor Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
                        customerName: 'Adam Cuppy',
                        customerTitle: 'Founder, EventsNYC',
                    },
                ]}
            /> */}
            <FAQ
                subheading={<Subheading id="pitanja">Česta pitanja</Subheading>}
                heading={
                    <>
                        Imate <HighlightedText>pitanja?</HighlightedText>
                    </>
                }
                description={
                    'Vrednost koju donosi naše rešenje mora da nadmašuje trošak – da ćete sa boljim prodajnim analizama, donositi bolje odluke koje će direktno povećavati prihod.'
                }
                faqs={[
                    {
                        question: 'Kako mi vaš alat može pomoći sa prodajom?',
                        answer: 'Automatizujemo analizu  prodajnih podataka – vidite koji proizvodi i klijenti donose zaradu, prepoznajte trendove, upoređujete prodavce ili lokacije i na osnovu analiza kreirajte prodajne strategije.',
                    },
                    {
                        question: 'Moram li znati raditi u Excelu ili BI alatima?',
                        answer: 'Ne, rešenje je intuitivno – izrađeno za korisnike koji žele konkretne odgovore, a ne tehničke složenosti. Sve vrste edukacija i održavanja sistema ostavite nama.',
                    },
                    {
                        question: 'Mogu li povezati svoj prodajni softver?',
                        answer: 'Da – alat se može integrisati sa različitim sistemima, zavisno o tehničkim mogućnostima. Bitno je imati podatke, a mi ćemo ih automatizovati.',
                    },
                    {
                        question: 'Koliko to košta?',
                        answer: 'Cena se formira prema veličini zahteva i kompleksnosti procesa. Rešenje je jedinstveno za svakog korisnika, pa shodno tome i definišemo cenu. Sve dogovaramo na sastanku.',
                    },
                    {
                        question: 'Kako izgleda proces implementacije rešenja?',
                        answer: (
                            <>
                                <p style={{ marginBottom: 10 }}>
                                    Kreirali smo dobar alat za procenu implementacije našeg rešenja koji daje porcenu da
                                    implementacija donese maksimalnu vrednost. Proces izgleda ovako:
                                </p>
                                <p>
                                    1. Prezentacija programa i analiza vaših potreba – Razumevanje vaših poslovnih
                                    izazova i ključnih pokazatelja (KPI).
                                </p>
                                <p>
                                    2. Pregled dostupnih izveštaja – Evaluacija postojećih podataka i mogućnosti
                                    prilagođavanja.
                                </p>
                                <p>
                                    3. Analiza podataka i integracija – Provera tehničkih zahteva i kompatibilnosti s
                                    vašim sistemima.
                                </p>
                                <p>4. Razvoj rešenja – Izrada rešenja po meri s relevantnim funkcionalnostima.</p>
                                <p>
                                    5. Testiranje i validacija – Pilot verzija i prilagođavanje prema povratnim
                                    informacijama.
                                </p>
                                <p>6. Implementacija i edukacija – Postavljanje sistema i obuka korisnika.</p>
                                <p>
                                    7. Podrška i unapređenje – Kontinuirano praćenje, optimizacija i prilagođenje
                                    rešenja.
                                </p>
                            </>
                        ),
                    },
                ]}
            />
            <TwoColContactUsWithIllustrationFullForm
                subheading=""
                features={[
                    // {
                    //     Icon: PhoneIcon,
                    //     title: '+381 65 600 1996',
                    // },
                    {
                        Icon: MailIcon,
                        title: 'info@poslovna-analitika.rs',
                    },
                ]}
            />
            <Footer />
        </AnimationRevealPage>
    );
};
